import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

function Toprated() {
  const [topratedData, topRatedData] = useState([]);
  const [type, setType] = useState("/movie/popular");
  const api_key = "1c349502ffa6fe67721a2ea4260bed9f";
  const api_url = "https://api.themoviedb.org/3/";

  const getResponseData = async () => {
    const data = await fetch(
      `${api_url}/${type}?api_key=${api_key}&language=en-US&page=1`
    );
    const response = await data.json();
    console.log("res", response.results);
    topRatedData(response.results);
  };
  useEffect(() => {
    getResponseData();
  }, [type]);
  return (
    <>
      <section className="top-rated">
        <div className="container">
          <p className="section-subtitle">Online Streaming</p>

          <h2 className="h2 section-title">Movies</h2>

          <ul className="filter-list">
            <li>
              <button
                onClick={() => setType("/movie/upcoming")}
                className="filter-btn"
              >
                Upcoming movies
              </button>
            </li>

            <li>
              <button
                onClick={() => setType("/movie/top_rated")}
                className="filter-btn"
              >
                Top rated
              </button>
            </li>

            <li>
              <button
                onClick={() => setType("/movie/popular")}
                className="filter-btn"
              >
                Popular movies
              </button>
            </li>
          </ul>

          <ul className="movies-list">
            {topratedData.map((item) => (
              <li>
                <div className="movie-card">
                  <Link to={"/movie-details/" + item.id}>
                    <figure className="card-banner">
                      <img
                        src={`https://image.tmdb.org/t/p/w500/${item.poster_path}`}
                        alt=""
                      />
                    </figure>
                  </Link>

                  <div className="title-wrapper">
                    <Link to={"/movie-details/" + item.id}>
                      <h3 className="card-title">{item.title}</h3>
                    </Link>

                    <time datetime="2022">{item.release_date}</time>
                  </div>

                  <div className="card-meta">
                    <div className="badge badge-outline">
                      {item.original_language}
                    </div>

                    <div className="rating">
                      <ion-icon name="star"></ion-icon>

                      <data>{item.vote_average}</data>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </>
  );
}

export default Toprated;
